
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { myAccountMenu } from '@xt/client/dataSource/my-v2/index'
import OrderAccount from '../../components/OrderAccount.vue'
import BishanAccount from '../../components/BishanAccount.vue'
import CoinAccount from '../../components/CoinAccount.vue'
import PacksAccount from '../../components/PacksAccount.vue'
import ExchangeAccount from '../../components/ExchangeAccount.vue'

@Component({
  components: {
    OrderAccount,
    BishanAccount,
    CoinAccount,
    PacksAccount,
    ExchangeAccount
  },
  asyncData(ctx) {
    const { active } = ctx.query
    const menu = myAccountMenu.find(item => item.value === active)

    if (!active || !menu)
      return {
        active: myAccountMenu[0].value,
        currentComponentName: myAccountMenu[0].component
      }

    const { value, component } = menu

    return {
      active: value,
      currentComponentName: component
    }
  }
})
export default class extends Vue {
  active: string
  currentComponentName: string

  get myAccountMenu() {
    return myAccountMenu
  }

  hanldeChangeMenu(key: string): void {
    if (this.active === key) return

    this.active = key

    this.currentComponentName = this.myAccountMenu.find(item => item.value === key)!.component

    this.$router.push({
      path: '/myv2/account',
      query: {
        active: key
      }
    })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
